import { type Theme, colorsPalette } from '@lingoda/ui';
import type { CSSProperties } from 'react';

interface WidgetStylesProps {
    theme: Theme;
    challengeName: string;
    joined: boolean;
}

interface WidgetStyles {
    colors: {
        subtitle: string;
        title: string;
        status: string;
    };
    background?: string;
    ':hover'?: CSSProperties;
    ':active'?: CSSProperties;
    unjoinedBlock: {
        colors: {
            description: string;
            buttons?: string;
        };
    };
}

const challengeGradients = {
    'february-2024': 'linear-gradient(100deg, #153BFF -150.93%, #90C 103.43%)',
};

export const getWidgetStyles = ({
    theme,
    challengeName,
    joined,
}: WidgetStylesProps): WidgetStyles => {
    switch (challengeName) {
        case 'february-2024':
            return {
                colors: {
                    subtitle: joined ? colorsPalette.blackAlpha[60] : colorsPalette.whiteAlpha[70],
                    title: joined ? theme.palette.text.primary : theme.colors.text.inverse,
                    status: joined ? theme.palette.text.secondary : colorsPalette.whiteAlpha[70],
                },
                background: joined ? undefined : challengeGradients['february-2024'],
                ':hover': joined
                    ? undefined
                    : {
                          background: challengeGradients['february-2024'],
                          filter: 'brightness(0.9)',
                      },
                unjoinedBlock: {
                    colors: {
                        description: colorsPalette.whiteAlpha[60],
                        buttons: theme.colors.text.inverse,
                    },
                },
            };
        default: {
            return {
                colors: {
                    subtitle: colorsPalette.blackAlpha[60],
                    title: theme.palette.text.primary,
                    status: theme.palette.text.secondary,
                },
                unjoinedBlock: {
                    colors: {
                        description: theme.palette.text.secondary,
                    },
                },
            };
        }
    }
};
